import {
  ACRONYMS as ACRONYMS_SSCP,
  GLOSSARY as GLOSSARY_SSCP,
  FLASHCARDS as FLASHCARDS_SSCP,
  QUESTIONS as QUESTIONS_SSCP,
} from "./sscp";

import {
  ACRONYMS as ACRONYMS_CCSP,
  GLOSSARY as GLOSSARY_CCSP,
  FLASHCARDS as FLASHCARDS_CCSP,
  QUESTIONS as QUESTIONS_CCSP,
} from "./ccsp";

import {
  ACRONYMS as ACRONYMS_CISSP,
  GLOSSARY as GLOSSARY_CISSP,
  FLASHCARDS as FLASHCARDS_CISSP,
  QUESTIONS as QUESTIONS_CISSP,
  OLD_QUESTIONS as OLD_QUESTIONS_CISSP,
  OLD_FLASHCARDS as OLD_FLASHCARDS_CISSP
} from "./cissp";

export const BUNDLE_ACRONYMS = {
  sscp: ACRONYMS_SSCP,
  ccsp: ACRONYMS_CCSP,
  cissp: ACRONYMS_CISSP,
};

export const BUNDLE_GLOSSARY = {
  sscp: GLOSSARY_SSCP,
  ccsp: GLOSSARY_CCSP,
  cissp: GLOSSARY_CISSP,
};

export const BUNDLE_FLASHCARDS = {
  sscp: FLASHCARDS_SSCP,
  ccsp: FLASHCARDS_CCSP,
  cissp: FLASHCARDS_CISSP,
  cissp_old: OLD_FLASHCARDS_CISSP,
};

export const BUNDLE_QUESTIONS = {
  sscp: QUESTIONS_SSCP,
  ccsp: QUESTIONS_CCSP,
  cissp: QUESTIONS_CISSP,
  cissp_old: OLD_QUESTIONS_CISSP,
};